import { useMemo } from 'react';
import Markdown, { type Components } from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { vaultFileUrl } from '../navigation.js';

const EXTERNAL_RE = /^[a-zA-Z][a-zA-Z0-9+.-]*:/;

/**
 * Non-interactive markdown renderer for canvas cards: links render as styled
 * text (no navigation), vault-relative images resolve through /vault/,
 * checkboxes are read-only. Kept deliberately lighter than the editor's
 * reading mode — canvas cards are previews, not editors.
 */
export function CanvasMarkdown({ md }: { md: string }) {
  const components = useMemo<Components>(
    () => ({
      a: ({ node: _node, children }) => <span className="cv-md-link">{children}</span>,
      img: ({ node: _node, src, alt, ...rest }) => {
        const url = typeof src === 'string' ? src : '';
        const resolved =
          url && !EXTERNAL_RE.test(url) && !url.startsWith('//') && !url.startsWith('/')
            ? vaultFileUrl(decodeURIComponent(url))
            : url;
        return <img {...rest} src={resolved} alt={alt ?? ''} loading="lazy" draggable={false} />;
      },
      input: ({ node: _node, disabled: _disabled, ...rest }) => {
        if (rest.type === 'checkbox') {
          return <input {...rest} readOnly onChange={() => {}} />;
        }
        return <input {...rest} />;
      },
    }),
    [],
  );
  return (
    <div className="cv-md">
      <Markdown remarkPlugins={[remarkGfm]} components={components}>
        {md}
      </Markdown>
    </div>
  );
}
